import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { getPurchasedNft } from "../../API/functions";

export const usePurchasedNft = ({ walletAddress,tier }) => {
  const { data, error, isLoading,refetch } = useQuery({
    queryKey: ["getpurchasedNft", walletAddress,tier], 
    queryFn: () => getPurchasedNft({ walletAddress,tier}),  
    onSuccess: (data) => {
      toast.success(data.message);
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "An error occurred");
    },
  });

  return { data, error, isLoading ,refetch};
};

